import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const ITunesIconSvg = ({
  color = "primary",
  bg = "#f5f9f9",
  iconStyle,
  ...rest
}) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-5.2 0 28 18.1"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G>
        <Path
          fill={color}
          d="m8.99998.447266c-4.97066 0-8.99998 4.029314-8.99998 8.999984 0 4.97065 4.02932 9.00005 8.99998 9.00005 4.97072 0 9.00002-4.0293 9.00002-9.00005 0-4.97067-4.0293-8.999984-9.00002-8.999984zm0 .993334c4.42142 0 8.00672 3.58525 8.00672 8.00668 0 4.42142-3.5853 8.00672-8.00672 8.00672-4.42143 0-7.99917-3.5853-7.99917-8.00672 0-4.42143 3.57774-8.00668 7.99917-8.00668z"
        />
        <Path
          fill={color}
          d="m12.7487 3.44531-6.24113 1.68765h-.00723v2.53863h.00723v4.53911c-.27305-.1643-.60779-.2618-.96743-.2618-.92644 0-1.67295.6434-1.67295 1.4329 0 .7898.74672 1.4258 1.67295 1.4258.92622 0 1.71345-.6366 1.68042-1.4257l-.01701-.4051-.0412-5.48723 4.93185-1.33125v5.01188c-.288-.1985-.6555-.32-1.0547-.32-.9265 0-1.67322.6434-1.67322 1.4329 0 .7899.74672 1.4258 1.67322 1.4258.9264 0 1.705-.6359 1.705-1.4258 0-.0074.0003-.0144 0-.0218l.0045-6.27778v-2.53821z"
        />
      </G>
    </Svg>
  )
}

export default ITunesIconSvg
